import { Navigate, Outlet } from "react-router-dom";
import { loginService } from "../utils/login";
import React, { ReactNode } from "react";

interface IPrivateRouteProps {
  redirectTo: string;
}

export function PrivateRoute({ redirectTo }: IPrivateRouteProps) {

  /* TODO check redirect to mosaic without this code:
  if (rest.path === "/") {
    window.location.href = "/mosaic";
    return <Route path="/mosaic" element={<Mosaic />} />;
  }
  */
  let isAuthenticated = loginService.verifyAuthentification();
  return isAuthenticated ? <Outlet/> : <Navigate to={redirectTo} />;
};

